import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// TODO: use a more robust notification like this once we can separate node and web code
// import notifier from 'node-notifier';
import { getInDomain } from '../../domains/externalUtils';
import { getArt } from '../../lib/ArtUtils';
import { isElectron } from '../../lib/ClientInfoUtils';
import { isHidden } from '../../lib/PageVisibility';

class Notification extends React.Component {
  static propTypes = {
    artistName: PropTypes.string,
    art: PropTypes.string,
    title: PropTypes.string,
    isElectronProp: PropTypes.bool,
    isHiddenProp: PropTypes.bool,
  };
  componentWillReceiveProps(nextProps) {
    // nextProps.title can be empty if it's audio ad
    if (
      nextProps.isHiddenProp &&
      nextProps.isElectronProp &&
      nextProps.title &&
      this.props.title !== nextProps.title
    ) {
      window.DesktopBridge.showNotification({
        title: nextProps.title,
        message: nextProps.artistName,
        imageUrl: nextProps.art,
      });
    }
  }
  render() {
    return null;
  }
}

export function mapStateToProps(state) {
  const track = getInDomain('playback.utils.getCurrentTrackFromActivePlaylist', null)(state);
  let title;
  let artistName;
  if (track !== null) {
    title = getInDomain('playback.utils.getAttributeForTrackFromActivePlaylist', '')(
      state,
      track,
      'name',
    );
    artistName = getInDomain('playback.utils.getAttributeForTrackFromActivePlaylist', '')(
      state,
      track,
      'artistName',
    );
  }
  const isElectronProp = isElectron(state);
  const isHiddenProp = isHidden(state);

  return {
    title,
    artistName,
    art: getArt(track, 90, state),
    isHiddenProp,
    isElectronProp,
  };
}

export default connect(mapStateToProps)(Notification);
